import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from '../reducers';
import { reduxReactRouter, routerStateReducer, ReduxRouter } from 'redux-router';
// import { devTools } from 'redux-devtools';
import createSagaMiddleware from 'redux-saga'
import createHistory from 'history/lib/createBrowserHistory';
import routes from '../routes';

const sagaMiddleware = createSagaMiddleware()

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const createStoreWithMiddleware = composeEnhancers(
  // Save for redux middleware
  applyMiddleware(sagaMiddleware),
  reduxReactRouter({
    createHistory
  }),
)(createStore);

const configureStore = (initialState) => {
  const store = createStoreWithMiddleware(rootReducer, initialState);

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers');
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}

export { sagaMiddleware, configureStore }



/** WEBPACK FOOTER **
 ** ./src/store/configureStore.js
 **/